import React from "react";
import './copyright.styles.css'

export default function Copyright() {
    var date = new Date();
    var year = date.getFullYear();

    return (
        <div className="ui shbg-pallet footer-bg sh-footer vertical segment no-border no-radius" id="copyrightMainDiv">
            <div className="ui grid container">
                <div className="row">
                    <div className="column">
                        <div className="ui tiny header" id="copyrightText">
                            &copy; 2006 -
                            <span id="currentYear"> { year }</span> Copyright, Centre for Computational Technologies Pvt. Ltd. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}